import { render, staticRenderFns } from "./window_switch.vue?vue&type=template&id=ee6f468c&"
import script from "./window_switch.vue?vue&type=script&lang=js&"
export * from "./window_switch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports